import { useContext, useEffect, useState } from "react";
import { aoiService } from "../Services/aoiService";
import EditIcon from '../Assets/img/icon-edit-grey.svg';
import DeleteIcon from '../Assets/img/icon-delete.svg';
import ManageOrgModal from "../Components/ManageOrgModal";
import toast from "react-hot-toast";
import { hasPermission } from "../Utils/PermissionUtils";
import { UserContext } from "../Contexts/UserContext";
import { Permission } from "../Utils/Permission";
import { orgService } from "../Services/orgService";
import ManageGeoJsonModal from "../Components/UserProfile/ManageGeoJsonModal";

const ManageGeoJsonTypes = () => {
    const { user, selectedOrgId, geoJsonTypes, reloadGeoJsonTypes } = useContext(UserContext);
    const [showManageGeoJsonModal, setShowManageGeoJsonModal] = useState(false);
    const [geoJsonToEdit, setGeoJsonToEdit] = useState(null);

    const createGeoJsonType = () => {
        setGeoJsonToEdit(null);
        setShowManageGeoJsonModal(true);
    };

    const editGeoJsonType = (geoJsonTypeId) => {
        let geoJsonEdit = geoJsonTypes?.find(o => o.geoJsonTypeId == geoJsonTypeId);
        setGeoJsonToEdit(geoJsonEdit);
        setShowManageGeoJsonModal(true);
    };

    const save = (geoJson) => {
      geoJson.orgId = selectedOrgId;
      if(!!geoJson.geoJsonTypeId) {
        orgService.updateGeoJsonType(geoJson).then((r) => {
            reloadGeoJsonTypes(selectedOrgId);
            setShowManageGeoJsonModal(false);
            toast.success("GeoJson Type is updated successfully");
        }).catch((e) => {
            toast.error(e);
        });
      } else {
        orgService.createGeoJsonType(geoJson).then((r) => {
            reloadGeoJsonTypes(selectedOrgId);
            setShowManageGeoJsonModal(false);
            toast.success("GeoJson Type is created successfully");
        }).catch((e) => {
            toast.error(e);
        });
      }
    };

    return (
        <div className="form-content">
            <div className="form-head">
                <h3>Geo Json Types</h3> &nbsp; &nbsp;
                {
                    !user.isClientUser && hasPermission(user, Permission.GeoJsonTypeCreate, selectedOrgId) &&
                    <a className="add-link" onClick={createGeoJsonType}>+ Add GeoJsonType</a>
                }
            </div>
            <div className="table-responsive">
                <table className="table table-style">
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Line Color</th>
                            <th scope="col">Code</th>
                            <th scope="col">Weight</th>
                            <th scope="col">Fill Color</th>
                            <th scope="col">Code</th>
                            <th scope="col">Opacity</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            geoJsonTypes.sort((a, b) => a.name - b.name).map((t) => {
                                return <tr>
                                            <td>{t.name}</td>
                                            <td style={{backgroundColor: t.strokeColor}}> &nbsp;  &nbsp;  &nbsp; </td>
                                            <td>{t.strokeColor}</td>
                                            <td>{t.strokeWeight}</td>
                                            <td style={{backgroundColor: t.fillColor}}> &nbsp;  &nbsp;  &nbsp; </td>
                                            <td>{t.fillColor}</td>
                                            <td>{t.fillOpacity}</td>
                                            <td>
                                                {
                                                    hasPermission(user, Permission.GeoJsonTypeStyleUpdate, selectedOrgId) &&
                                                    <a onClick={()=>editGeoJsonType(t.geoJsonTypeId)}>
                                                        <img src={EditIcon} />
                                                    </a>
                                                }
                                                &nbsp; &nbsp; &nbsp; &nbsp; 
                                                {
                                                    hasPermission(user, Permission.GeoJsonTypeDelete, selectedOrgId) &&
                                                    <a onClick={()=>editGeoJsonType(t.geoJsonTypeId)}>
                                                        <img src={DeleteIcon} />
                                                    </a>
                                                }
                                            </td>
                                        </tr>;
                            })
                        }
                    </tbody>
                </table>
            </div>
            {
                showManageGeoJsonModal &&
                <ManageGeoJsonModal
                    setShowModal={setShowManageGeoJsonModal}
                    geoJson={geoJsonToEdit} 
                    save={save}
                />
            }
        </div>
    );
}

export default ManageGeoJsonTypes;